module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av313-33ea11351d9f5da80121a27e4b87e67f.jpg";